###
This filter escapes HTML code (by wrapping ``_.escape``).

Note: this filter is only necessary when using ``ng-bind-html`` with data that
should not be treated as HTML. (For example, with AngularStrap's tooltips.)
###
angular.module('rjmNg.filters').filter "escapeHtml", [
  () ->
    _.escape
]
